import React, { useState } from 'react'
import {
  Flex,
  FormField,
  Modal,
  PrimaryButton,
  space,
  TertiaryButton,
  TextInput,
  Tooltip,
  useModalModel
} from '@workday/canvas-kit-react'
import { saveIcon } from '@workday/canvas-system-icons-web'
import { PrimaryButtonColors } from '../../components/CanvasThemes'

export type SaveFeedDialogProps = {
  defaultName: string
  onSave: (name: string) => void
}

const SaveFeedDialog = ({ defaultName, onSave }: SaveFeedDialogProps) => {
  const [name, setName] = useState('')
  const model = useModalModel()
  return (
    <Modal model={model}>
      <Tooltip title="Save Feed">
        <Modal.Target as={TertiaryButton} icon={saveIcon} />
      </Tooltip>
      <Modal.Overlay>
        <Modal.Card>
          <Modal.Body>
            <FormField label="Feed Name">
              <TextInput
                placeholder={defaultName}
                value={name}
                onChange={event => setName(event.currentTarget.value)}
              />
            </FormField>
            <Flex flexDirection="row" gap={space.xs}>
              <PrimaryButton
                onClick={event => {
                  onSave(name === '' ? defaultName : name)
                  model.events.hide()
                }}
                colors={PrimaryButtonColors}
              >
                Save
              </PrimaryButton>
              <Modal.CloseButton>Cancel</Modal.CloseButton>
            </Flex>
          </Modal.Body>
        </Modal.Card>
      </Modal.Overlay>
    </Modal>
  )
}

export default SaveFeedDialog
